/* NgRx */
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {CoachGroupsListState} from './coach-groups-list.reducer';

// Selector functions
const groupsListData =
  createFeatureSelector<CoachGroupsListState>('ss-cord.coach-groups-list');


// Get Groups List
export const groupsList = createSelector(
  groupsListData,
  (state: CoachGroupsListState) => state.groupsList
);

export const groupsTypeFilter = createSelector(
  groupsListData,
  (state: CoachGroupsListState) => state.groupsTypeFilter
);

export const groupsStatusFilter = createSelector(
  groupsListData,
  (state: CoachGroupsListState) => state.groupsStatusFilter
);

export const participantFilter = createSelector(
  groupsListData,
  (state: CoachGroupsListState) => state.participantFilter
);

export const groupFilter = createSelector(
  groupsListData,
  (state: CoachGroupsListState) => state.groupFilter
);
